import {
  Box,
  Stack,
  Typography,
  Checkbox,
  FormControlLabel,
  TextField,
  Select,
  MenuItem,
  Button,
  Divider,
} from "@mui/material";
import { FormProvider } from "react-hook-form";

import { useConfigLogic } from "./useConfigLogic";
import { WORKING_DAYS_ENUM } from "./helper/types";

function ConfigMutation() {
  const {
    isButtonLoading,
    isSuccess,
    hours,
    days,
    methods,
    workingHours,
    watch,
    register,
    onSubmit,
    handleSubmit,
  } = useConfigLogic()

  return (
    <FormProvider {...methods}>
      <Stack
        onSubmit={handleSubmit(onSubmit)}
        component="form"
        spacing={4}
        sx={{ p: 3, maxWidth: 500, bgcolor: "background.paper", borderRadius: 2 }}
      >
        <Typography variant="h6">
          Manage working hours and contact information for your landing page.
        </Typography>

        {/* Working Hours */}
        <Box sx={{ border: "1px solid #ddd", borderRadius: 2, p: 2 }}>
          <Typography variant="subtitle1" fontWeight="bold">
            Working Hours
          </Typography>
          <Typography variant="body2" color="text.secondary" mb={2}>
            Set the days and time your business is available.
          </Typography>

          <Stack spacing={2}>
            {days?.map((day) => {
              const { key } = day
              const { enabled, to, from } = workingHours[key]

              return (
                <Stack
                  key={key}
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                  spacing={2}
                >
                  <FormControlLabel
                    control={(
                      <Checkbox
                        checked={enabled || false}
                        {...register(`workingHours.${key as WORKING_DAYS_ENUM}.enabled`)}
                      />
                    )}
                    label={day.label}
                  />

                  <Box
                    display="flex"
                    gap={1}
                  >
                    {!enabled ? (
                      <Typography color="text.secondary">Closed</Typography>
                    ) : (
                      <>
                        <Select
                          size="small"
                          defaultValue={from}
                          value={from}
                          {...register(`workingHours.${key as WORKING_DAYS_ENUM}.from`)}
                        >
                          {hours.map((h) => (
                            <MenuItem key={h} value={h}>
                              {h}
                            </MenuItem>
                          ))}
                        </Select>
                        <Select
                          size="small"
                          defaultValue={to}
                          value={to}
                          {...register(`workingHours.${key as WORKING_DAYS_ENUM}.to`)}
                        >
                          {hours.map((h) => (
                            <MenuItem key={h} value={h}>
                              {h}
                            </MenuItem>
                          ))}
                        </Select>
                      </>
                    )}
                  </Box>
                </Stack>
              )
            })}
          </Stack>
        </Box>

        <Box sx={{ border: "1px solid #ddd", borderRadius: 2, p: 2 }}>
          <Typography variant="subtitle1" fontWeight="bold">
            Contact Information
          </Typography>
          <Typography variant="body2" color="text.secondary" mb={2}>
            Set how users can reach you.
          </Typography>

          <Stack spacing={2}>
            <TextField
              label="Email"
              variant="outlined"
              fullWidth
              value={watch("contactInfo.email")}
              {...register("contactInfo.email")}
            />
            <TextField
              label="Phone"
              variant="outlined"
              fullWidth
              value={watch("contactInfo.phone1")}
              {...register("contactInfo.phone1")}
            />
            <TextField
              label="Phone"
              variant="outlined"
              fullWidth
              value={watch("contactInfo.phone2")}
              {...register("contactInfo.phone2")}
            />
          </Stack>
        </Box>

        <Divider />
        {/* {largeImageMessage && <StyledFormHelperText id="messages">{largeImageMessage}</StyledFormHelperText>} */}
        <p>{isSuccess}</p>
        <Button
          type="submit"
          variant="contained"
          color="primary"
          disabled={isButtonLoading}
        >
          Save
        </Button>
      </Stack>
    </FormProvider>
  );
}

export default ConfigMutation
